module.exports = __webpack_public_path__ + "media/assets/images/pq4-eb48aea681e5188a533da5abe8174bb1.svg";